import React from "react";
import { Box, Typography } from "@mui/material";

interface StepDotsProps {
  activeIndex: number;
  totalSteps: number;
  sx?: React.CSSProperties;
}

const ACTIVE_DOT_SIZE = "12px";
const DOT_SIZE = "10px";

export const StepDots = ({ activeIndex, totalSteps, sx }: StepDotsProps) => {
  return (
    <Box
      sx={{
        zIndex: "100",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {Array.from({ length: totalSteps }, (_, index) => {
          const isComplete = index <= activeIndex;
          const size = index === activeIndex ? ACTIVE_DOT_SIZE : DOT_SIZE;
          return (
            <React.Fragment key={index}>
              {index > 0 && (
                <Box
                  sx={{
                    width: "40px",
                    height: "2px",
                    backgroundColor: isComplete ? "primary.main" : "border",
                  }}
                />
              )}
              <Box
                sx={{
                  width: size,
                  height: size,
                  borderRadius: "50%",
                  backgroundColor: isComplete ? "primary.main" : "border",
                }}
              />
            </React.Fragment>
          );
        })}
      </Box>
      <Typography
        variant="bodySmall"
        sx={{
          position: "absolute",
          top: "100%",
          marginTop: "6px",
          whiteSpace: "nowrap",
          color: "text.secondary",
        }}
      >
        Step {activeIndex + 1} of {totalSteps}
      </Typography>
    </Box>
  );
};
